import { DataBean } from "../DataBean";

export class ImportBanking extends DataBean {


    public async importBankingStatement(idBankingStatement:any,filename:any,directorya:any,dataStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importBankingStatement_Number_String_String_String", [idBankingStatement,filename,directorya,dataStore]);
    }

}